
















































































































































































































































import { Component, Vue, Watch, Emit } from "vue-property-decorator";
import FlightOrderChangeModal from "./modals/flightOrderChangeModal.vue";
import moment from "moment";
import FlightOrderTreeList from "@/store/entities/flight/flightOrderTreeList";
import FlightChangeInput from "@/store/entities/flight/flightChangeInput";
import FlightChangeGeneral from "@/store/entities/flight/flightChangeGeneral";

@Component({
  components: { FlightOrderChangeModal },
})
export default class FlightOrderChange extends Vue {
  isOpened:boolean=true;
  isOpenModal: boolean = false;
  headersFlightOrder: any[] = [];
  mockDataFlightOrder: any[] = [];
  headersPassengers: any[] = [];
  mockDataPassengers: any[] = [];
  departureDate: Date = null;
  arrivalDate: Date = null;
  breadcrumbsItems: any[] = [];
  items: any[] = [];
  active_tab: number = 0;
  selected: any[] = [];

  startDate: Date = null;
  startDateMenu: boolean = false;

  endDate: Date = null;
  endDateMenu: boolean = false;

  flightOrderTreeList: FlightOrderTreeList[] = [];
  flightChangeInput: FlightChangeInput = new FlightChangeInput();
  arrivals: string="";
  selection: any[] = [];
  flightChangeGeneral: FlightChangeGeneral[] = [];


  get getEndDate() {
    return this.endDate
      ? (this.flightChangeInput.flightDateEnds = moment(this.endDate).format(
          "DD-MM-yyyy"
        ))
      : "";
  }

  get getStartDate() {
    return this.startDate
      ? (this.flightChangeInput.flightDateStarts = moment(
          this.startDate
        ).format("DD-MM-yyyy"))
      : "";
  }
      get getMinEndDate() {
    return this.startDate
      ? moment(this.startDate)
          .add(1, "days")
          .toISOString()
          .slice(0, 10)
      : "";
  }
  async searchFlights() {
    this.getSerialization();
    const data = this.flightChangeInput;
    data.departureDateStarts = moment(this.startDate).format("MM-DD-yyyy");
    data.departureDateEnds = moment(this.endDate).format("MM-DD-yyyy");
    data.toAirportIds = this.flightChangeInput.arrivalAirports;
    data.fromAirportIds=this.flightChangeInput.departureAirports;
    data.flightNo = this.flightChangeInput.flightNo;
 
    data.isActive = this.flightChangeInput.isActive;
 
    if (!moment(this.startDate).isValid()) {
      data.departureDateStarts = moment()
        .add(-3, "months")
        .format("MM-DD-yyyy");
    }
    if (!moment(this.endDate).isValid()) {
      data.departureDateEnds = moment()
        .add(8, "months")
        .format("MM-DD-yyyy");
    }

    await this.$store
      .dispatch({
        type: "flight/getFlightOrderTreeList",
        data: this.flightChangeInput,
      })
      .then((res) => {
        let newArray = [];
        const data = res.data.result;

        for (let i = 0; i < data.length; i++) {
          newArray.push({
            id: i,
            name: data[i].name,
            children: [],
          });

          let childs = newArray[i].children;

          for (let j = 0; j < data[i].children.length; j++) {
            childs.push({
              id: data[i].children[j].dataAttributes.id,
              name: data[i].children[j].name,
            });
          }
        }
        this.flightOrderTreeList = newArray;

        this.flightOrderTreeList.sort(function (a, b) {
  if (a.name < b.name) {
    return -1;
  }
  if (a.name > b.name) {
    return 1;
  }
  return 0;
});
      })
      .catch((err) => console.log(err));
  }




  getSerialization() {
    if (this.arrivals.length == 7) {
      const departure = this.arrivals.substring(0, 3);
      const arrival = this.arrivals.substring(4, 7);
      this.flightChangeInput.arrivalAirports=arrival;
      this.flightChangeInput.departureAirports=departure;
    }
    else{
      this.flightChangeInput.arrivalAirports=null;
      this.flightChangeInput.departureAirports=null;
    }
  }

    async addSelectionItem(item: any) {
    if (item.children == undefined) {
      await this.getFlightOrder(item);
    }
  }

  async getFlightOrder(input) {
    var itemIndex = this.flightChangeGeneral.findIndex((x) => x.id == input);

    
    if (itemIndex != -1) {
      this.flightChangeGeneral.splice(itemIndex, 1);
    } else {
      await this.$store
        .dispatch({
          type: "flight/getFlightOrder",
          data: input,
        })
        .then((res) => {
          this.flightChangeGeneral.push(res.data.result);
        });

      
    }
    this.orderSelect();


  }


  filterData(item, queryText) {
  
  return (
    item.id.toLowerCase().includes(queryText.toLowerCase()) ||  
    item.name.toLowerCase().includes(queryText.toLowerCase())
  );
}


 orderSelect(){
  console.log("seçilen uçaklar",this.flightChangeGeneral);
  if(this.flightChangeGeneral.length>1){
    this.flightChangeGeneral.sort(this.compareDates);
   
  }
  console.log("UCAK",this.flightChangeGeneral[0].flight);
  const { fromAirportId, toAirportId } = this.flightChangeGeneral[0].flight;
  const airport = { fromAirportId, toAirportId };
  this.$store.state.flight.selectedFlightOrder=airport;
 
 }

  compareDates(a, b) {
  return moment(a.departureDate, "YYYY-MM-DD").diff(moment(b.departureDate, "YYYY-MM-DD"));
  }
  @Watch("selection")
  onPropertChangedSelection(newValue, old) {
  
    const firstLength = newValue.length;
    const lastLength = old.length;
    if (lastLength === 0 && firstLength > 1) {
      for (let item of newValue) {
        this.addSelectionItem(item.id);
      }
    } else if (firstLength > lastLength) {
      this.addSelectionItem(newValue[firstLength - 1].id);
    } else if (firstLength > 0 && firstLength < lastLength) {
      let difference = old.filter((x) => !newValue.includes(x));
      const index = old.indexOf(difference[0]);
      this.flightChangeGeneral.splice(index, 1);
    } else {
      this.flightChangeGeneral.length = 0;
    }
  }


  created() {
    (this.headersFlightOrder = [
      { text: "PNR", value: "pnr" },
      { text: "Havayolu Adı", value: "company" },
      { text: "Kalkış-Varış", value: "destination" },
      { text: "Sipariş Durumu", value: "orderStatus" },
      { text: "Yolcu Sayısı", value: "passengerNumber" },
      { text: "Oluşturulma Tarihi", value: "creationDate" },
    ]),
      (this.headersPassengers = [
        { text: "Uçuş sınıfı", value: "flightClass" },
        { text: "Yolcu Durumu", value: "passengerStatus" },
        { text: "İsim", value: "name" },
        { text: "Yolcu Türü", value: "passengerType" },
        { text: "Cinsiyet", value: "gender" },
        { text: "Doğum Günü", value: "birthday" },
        { text: "Pasaport", value: "passport" },
        { text: "Pasaport Geçerlilik Tarihi", value: "passportValidity" },
        { text: "Fiyat", value: "price" },
      ]),
      
      (this.breadcrumbsItems = [
        { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
        { text: "Uçuş", disabled: true },
        { text: "Uçuş Sipariş Değişikliği", disabled: true },
      ]);

    this.items = [
      {
        id: 1,
        name: "Antalya",
        children: [
          { id: 2, name: "AYT - ALA" },
          { id: 3, name: "AYT - DME" },
          { id: 4, name: "AYT - MOW" },
        ],
      },

      {
        id: 5,
        name: "Bodrum",
        children: [
          { id: 6, name: "BJV - DME" },
          { id: 7, name: "BJV - HRK" },
          { id: 8, name: "BJV - KBP" },
          { id: 9, name: "BJV - KBP" },
        ],
      },

      {
        id: 10,
        name: "St Petersburg",
        children: [{ id: 11, name: "LED - AER" }],
      },
    ];

    
  }



  openDetail() {
    this.isOpened = true;
  }
  closeDetail() {
    this.isOpened = false;
  }



  openModal() {
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
  }

  data() {
    return {};
  }
}
